import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

type ToastType = "success" | "error" | "info" | "warning";

interface Toast {
  id: string;
  message: string;
  type: ToastType;
  closable?: boolean;
}

interface ToastReducerState {
  /**
   * List of active toasts
   */
  toasts: Toast[];
}

const initialState: ToastReducerState = {
  toasts: [],
};

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    addToastAction: (
      state: ToastReducerState,
      action: PayloadAction<Omit<Toast, "id">>,
    ) => {
      const id = crypto.randomUUID();
      state.toasts.push({ ...action.payload, id });
    },
    removeToastAction: (
      state: ToastReducerState,
      action: PayloadAction<string>,
    ) => {
      state.toasts = state.toasts.filter(
        (toast) => toast.id !== action.payload,
      );
    },
  },
});

export const selectToasts = (state: RootState) => {
  return state.toast.toasts;
};

export const selectToastById = createSelector(
  [selectToasts, (_state: RootState, id: string) => id],
  (toasts, id): Toast | undefined => {
    return toasts.find((toast) => toast.id === id);
  },
);

export const { addToastAction, removeToastAction } = toastSlice.actions;

// eslint-disable-next-line import/no-default-export
export default toastSlice.reducer;
export type { ToastReducerState, Toast, ToastType };
